/**
 * url.utils.js
 * 
 * Centralizes environment detection and URL resolution.
 * Separates "Sustainability Work-in-Progress" logic from "Local Routing" logic.
 */

// 1. Environmental Flags
export const IS_LOCALHOST = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// This follows the .env file strictly for feature visibility
export const SUSTAINABILITY_DEV_MODE = process.env.REACT_APP_SUSTAINABILITY_DEV_MODE === "true";

export const forceShowImpact = () => {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  const val = (params.get('envimp') || params.get('envImp'))?.toLowerCase();
  if (val === '1' || val === 'true') return true;
  if (val === '0' || val === 'false') return false;
  return null;
};

export const forceHideCalculator = () => {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  const val = (params.get('hidecalc') || params.get('hideCalc'))?.toLowerCase();
  if (val === '1' || val === 'true') return true;
  if (val === '0' || val === 'false') return false;
  return null;
};

// 3. Routing Logic
const LOCAL_PHP_BASE = "http://localhost:8888";

export const getApiUrl = (path) => {
  // Local PHP server routing is purely based on the physical environment (localhost)
  if (IS_LOCALHOST) {
    return `${LOCAL_PHP_BASE}/${path}`;
  }
  
  // Production or Stage environments use relative paths (obfuscated)
  return path;
};
